import { render, staticRenderFns } from "./OnboardingStep1.vue?vue&type=template&id=2db32a1a&scoped=true&lang=pug"
import script from "./OnboardingStep1.vue?vue&type=script&lang=js"
export * from "./OnboardingStep1.vue?vue&type=script&lang=js"
import style0 from "./OnboardingStep1.vue?vue&type=style&index=0&id=2db32a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db32a1a",
  null
  
)

export default component.exports